import * as React from 'react';
import { htmlDecode } from '../helpers/functions';
import { motion } from 'framer-motion';
import cx from 'classnames';
import { SocialMedia } from './SocialMedia';

export function Footer({
  footerMap,
  footerMenuTitle,
  footerLocationsTitle,
  footerLocations,
  footerLogo,
  mainNav,
  socialLinks,
  copyright,
}) {
  const locations = JSON.parse(htmlDecode(footerLocations));
  return (
    <>
      {footerMap && (
        <div className="">
          {footerMap.topText && (
            <h2
              dangerouslySetInnerHTML={{
                __html: htmlDecode(footerMap.topText),
              }}
              className="uppercase text-center text-white bg-primary m-0 py-4 font-bold"
            />
          )}
          {footerMap.map && (
            <div
              className="clear-both overflow-hidden"
              dangerouslySetInnerHTML={{
                __html: htmlDecode(footerMap.map),
              }}
            />
          )}
          {footerMap.bottomText && (
            <h2
              dangerouslySetInnerHTML={{
                __html: htmlDecode(footerMap.bottomText),
              }}
              className="uppercase text-center text-white bg-secondary m-0 py-4 font-bold"
            />
          )}
        </div>
      )}
      <footer id="footer" className={cx(``)}>
        <div className="bg-primary">
          <div className="container flex flex-wrap lg:flex-nowrap py-12 px-4 lg:px-0">
            <div className="w-1/2 lg:w-2/12 flex justify-center">
              <div>
                {footerLogo && (
                  <picture className="mb-8 block">
                    <img src={footerLogo.url} alt={footerLogo.alt} />
                  </picture>
                )}
                {socialLinks && (
                  <SocialMedia
                    links={socialLinks}
                    color={`text-white`}
                    hover={`hover:text-secondary`}
                  />
                )}
              </div>
            </div>
            <div className="w-1/2 lg:w-3/12 lg:px-12">
              {footerMenuTitle && (
                <h3
                  className="text-white text-20 mt-0 mb-4"
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(footerMenuTitle),
                  }}
                />
              )}
              {mainNav && (
                <ul className="text-white m-0">
                  {mainNav.map((link, key) => (
                    <li className="mb-0" key={key}>
                      <a
                        href={link.url}
                        dangerouslySetInnerHTML={{
                          __html: htmlDecode(link.title),
                        }}
                        className="no-underline text-white text-14 font-bold hover:text-secondary"
                      />
                    </li>
                  ))}
                </ul>
              )}
            </div>
            <div className="w-full lg:w-7/12 mt-8 lg:mt-0">
              {footerLocationsTitle && (
                <h3
                  className="text-white text-20 mt-0 mb-4"
                  dangerouslySetInnerHTML={{
                    __html: htmlDecode(footerLocationsTitle),
                  }}
                />
              )}
              {locations && (
                <div className="flex flex-wrap text-14">
                  {locations.map((location, key) => (
                    <div
                      className="w-1/2 sm:w-1/3 px-2 text-white mb-10"
                      key={key}
                    >
                      {location.title && (
                        <strong
                          dangerouslySetInnerHTML={{ __html: location.title }}
                        />
                      )}
                      {location.address && (
                        <div
                          className="font-medium"
                          dangerouslySetInnerHTML={{ __html: location.address }}
                        />
                      )}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="bg-secondary">
          <div
            className="container text-white py-4 text-center lg:text-left px-4 lg:px-0"
            dangerouslySetInnerHTML={{ __html: htmlDecode(copyright) }}
          />
        </div>
        <div className="hidden w-full w-1/2 md:w-1/2 sm:w-1/2 w-1/3 md:w-1/3 sm:w-1/3 md:text-24 text-24"></div>
      </footer>
    </>
  );
}
